import React, { useState } from "react";
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { Navigate, useLocation } from "react-router-dom";
import { auth } from "../helpers/firebaseConfig";
import { useAuth } from "./AuthProvider";
import "./auth.css";

export default function LoginPage() {
  const { user, isLoading } = useAuth();
  const location = useLocation();
  const [isSigningIn, setIsSigningIn] = useState(false);
  const [error, setError] = useState("");
  const requestedReturnTo = String(location.state?.returnTo || "/");
  const returnTo = requestedReturnTo.startsWith("/") && !requestedReturnTo.startsWith("//")
    ? requestedReturnTo
    : "/";

  if (!isLoading && user) return <Navigate to={returnTo} replace />;

  const signIn = async () => {
    setIsSigningIn(true);
    setError("");
    try {
      const provider = new GoogleAuthProvider();
      provider.setCustomParameters({ prompt: "select_account" });
      await signInWithPopup(auth, provider);
    } catch (err) {
      if (String(err?.code || "") !== "auth/popup-closed-by-user") {
        setError(String(err?.message || "Could not sign in."));
      }
    } finally {
      setIsSigningIn(false);
    }
  };

  return (
    <main className="auth-page">
      <section className="auth-card">
        <div className="auth-brandMark">W</div>
        <h1>WUI-Go Login</h1>
        <p>Sign in to access WUI-Go tools.</p>
        <button className="auth-googleButton" type="button" disabled={isSigningIn || isLoading} onClick={signIn}>
          <span className="auth-googleGlyph">G</span>
          {isSigningIn ? "Signing in…" : "Continue with Google"}
        </button>
        {error ? <div className="auth-error" role="alert">{error}</div> : null}
      </section>
    </main>
  );
}
